module.exports = __webpack_public_path__ + "static/media/n_icon_what@2.e4ff92c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_what@2.png
// module id = 388
// module chunks = 0 1